// extracted by mini-css-extract-plugin
module.exports = {"CustomResults__group-name__3VFc0":"CustomResults__group-name__3VFc0"};